export const getDiscountBase = (prices, product_id) => {
    const d_good = Number(prices[product_id].discounts.discount_good);
    const d_add = Number(prices[product_id].discounts.discount_additional);
    const d_group = Number(prices[product_id].discounts.discount_group);
    const d_customer = Number(prices[product_id].discounts.discount_customer);
    const pc_customer = Number(prices[product_id].discounts.pricechange_customer);
    const pc_group = Number(prices[product_id].discounts.pricachanges_groups);
    let complete_discount = d_customer + d_group + d_good + pc_group + pc_customer;

    if (d_add && d_add < 0)
    {
        complete_discount = complete_discount + d_add;
    }

    return complete_discount / 100;
}

export const getAdditionalVoc = (prices, product_id) => {
    return Number(prices[product_id].discounts.discount_additional_voc) / 100;
}
